import React from 'react';
import { formatItemTag, formatItemTagList } from 'selectors/tag.selectors';
import TagFormInput from './input';

const config = {
  // List Table
  list: {
    // Table Columns
    format: formatItemTagList,
    columns: [
      {
        title: 'Tag Collection',
        dataIndex: 'tag__collection__name',
        width: '200px',
        sorter: true,
        render: (text, record) => (record.tag.collection.used_by_optimiser ? `** ${record.tag.collection.name}` : record.tag.collection.name)
      },
      {
        title: 'Used by Optimiser',
        dataIndex: 'tag__collection__used_by_optimiser',
        width: '160px',
        align: 'center',
        sorter: true,
        render: (text, record) => (record.tag.collection.used_by_optimiser ? 'Yes' : 'No')
      },
      {
        title: 'Tag',
        dataIndex: 'tag__name',
        sorter: true,
        defaultSortOrder: 'ascend',
        render: (text, record) => (record.tag.name)
      },
      {
        title: 'Start Date',
        dataIndex: 'start_date',
        width: '160px',
        align: 'center',
        sorter: true,
        render: (text, record) => (record.start_date && record.start_date.isValid() ? record.start_date.format('DD-MM-YYYY HH:mm') : 'N/A')
      }, {
        title: 'Expiry Date',
        dataIndex: 'expiry_date',
        width: '160px',
        align: 'center',
        sorter: true,
        render: (text, record) => (record.expiry_date && record.expiry_date.isValid() ? record.expiry_date.format('DD-MM-YYYY HH:mm') : 'Never')
      }
    ],
    // Deleting
    confirmMessage: () => (
      <div>
        <p>
          Are you sure you wish to delete the tag ?
        </p>
        <p>
          This action cannot be undone.
        </p>
      </div>
    ),
    // Filtering
    sorter: {
      field: 'tag__name',
      order: 'ascend'
    },
    filters: {},
    customFilters: {
      tag__collection__name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['tag__collection__name'],
        searchValue: ''
      },
      tag__name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['tag__name'],
        searchValue: ''
      }
    },
    // General
    title: 'Tags',
    commands: {
      showDelete: false,
      showAdd: false
    }
  },
  // Detail Screen
  detail: {
    // General
    format: formatItemTag,
    emptyMessage: 'Please select a Record',
    title: 'Tag',
    component: props => (
      <TagFormInput
        {...props}
        inputFormItemLayout={{
          inputLayout: {
            labelCol: {
              xs: { span: 24 },
              sm: { span: 10 }
            },
            wrapperCol: {
              xs: { span: 24 },
              sm: { span: 14 }
            }
          },
          row: {
            gutter: 16
          },
          col: {
            span: 12
          }
        }}
        title="Tag"
      />
    )
  }
};

export default config;
